import * as React from 'react';

interface AddEntryProps {
  onClick: () => void;
}

export const AddEntry: React.SFC<AddEntryProps> = (props) => {
  return (
    <div onClick={props.onClick}>
      Add
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/addEntry.tsx